import React from 'react';


import {inputConstants} from '../../Input';
import {passwordConfirmationFormConstants} from '../../../../contexts/User/PasswordConfirmationForm';

import FormElement from '../index';
import FormFieldError from '../../FormFieldError';

import PasswordInput from '../../Input/PasswordInput';


function FormPassword(props) {

    return (
        <FormElement {...props}>

            <PasswordInput
                {...props}
                autoComplete={inputConstants.AUTOCOMPLETE_PASSWORD_NEW}
                maxLength={passwordConfirmationFormConstants.PASSWORD_MAX_LENGTH}
            />

            <FormFieldError error={props.error}/>

            {props.children}

        </FormElement>
    );
}


FormPassword.propTypes = {
    ...FormElement.propTypes,
    ...PasswordInput.propTypes
};

FormPassword.defaultProps = {
    ...FormElement.defaultProps,
    ...PasswordInput.defaultProps
};


export default FormPassword;
